
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";
import {mapState} from "vuex";
import Deferrable from "@/libs/common/delegate/Deferrable";
import {Duct} from "@/libs/Duct";
import Defer from "@/libs/Defer";
import MatchInterface from "@/libs/model/MatchInterface";
import MatchStatus from "@/components/Fixture/MatchStatus.vue";
import DateComponent from "@/components/Fixture/DateComponent.vue";
import MatchInfo from "@/components/Match/MatchInfo.vue";
import groupBy from 'lodash/groupBy';

@Component({
  components: { MatchInfo, MatchStatus, DateComponent },
  computed: {
    ...mapState({
      worldCupMatches: "worldCupMatches"
    })
  }
})
export default class Fixture
  extends WorldCupComponent
  implements Deferrable {
  config: any;
  worldCupMatches: any;
  isPreloaded: boolean;
  isMounted: boolean;
  defer: Defer;

  getMatches(): Array<MatchInterface> {
    let data = this.getStoreData(this.worldCupMatches);

    if (!data) {
      return [];
    }

    if (!data.match) {
      return [];
    }
    const newData = {};

    data.match.map((item: MatchInterface) => {

      if (newData[item.matchInfo.localDate]) {
        newData[item.matchInfo.localDate] = [...newData[item.matchInfo.localDate], {...item}]
      } else {
        newData[item.matchInfo.localDate] = [{...item}]
      }
    })
    return Object.entries(newData).sort((a, b) => a[0].localeCompare(b[0]));
  }
  get matches(): Array<MatchInterface> {
    let data = this.getStoreData(this.worldCupMatches);
    if (!data) {
      return [];
    }
    if (!data.match) {
      return [];
    }

    return this.getGroupMatches(data.match.filter(item=>item.liveData.matchDetails.matchStatus !== "Played"));
  }

  getGroupMatches( data:Array<MatchInterface>): any {
    const matchesGroupedByStage = groupBy(data.reverse(), item => item.matchInfo.stage.name);
    const groupedDataByDate = {};
    for(const k in matchesGroupedByStage) {
      const matchesGroupedByDate = groupBy(matchesGroupedByStage[k], val => val.matchInfo.localDate);
      groupedDataByDate[k] = matchesGroupedByDate;
    }
    return groupedDataByDate;
  }
  getSortedMatches(): Array<MatchInterface> {
    let data = this.getStoreData(this.worldCupMatches);
    if (!data) {
      return [];
    }

    if (!data.match) {
      return [];
    }

    return data.match;
  }

  getContestant(item: MatchInterface) {
    if (!item.matchInfo) {
      return "";
    }

    if (!item.matchInfo.contestant) {
      return "";
    }

    let contestants = item.matchInfo.contestant;
    return contestants[0].name + " vs " + contestants[1].name;
  }

  getResult(item: MatchInterface) {
    let liveData = item.liveData;
    if (!liveData) {
      return "--";
    }
    let matchDetails = liveData.matchDetails;
    if (!matchDetails) {
      return "--";
    }

    let scores = matchDetails.scores;
    if (!scores) {
      return "--";
    }

    return `HOME: ${scores.total.home} / AWAY: ${scores.total.away}`;
  }

  created() {
    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted() {
    this.isMounted = true;
    this.onDebug(this, "Fixture:mounted", {});
  }

  onDefer() {
    if (this.isPreloaded && this.isMounted) {
      return false;
    }
    return true;
  }

  onReady() {
  }

  onPreloadDone() {
    this.isPreloaded = true;
  }

}
